<template>
    <!--    <div class="splash">-->
    <div class="lds-css ng-scope">
        <div style="width:100%;height:100%" class="lds-heart">
            <div></div>
        </div>
    </div>
    <!--        <div class="imageSplash">-->
    <!--            <img class="paddB" src="../../assets/image/background_intro.png" alt=""/>-->
    <!--    </div>-->
    <!--    </div>-->
</template>
<script>

    import oracle from "@/oracle";

    export default {
        name: "splash",
        data() {
            return {}
        },
        methods: {
            handleAnimation: function (anim) {
                this.anim = anim;
                this.play();
            },
            play: function () {
                this.anim.play();
            },
            handshakeResult(response) {
                oracle.setData("intro", response.data)
                const intro = localStorage.getItem("intro");
                setTimeout(() => {
                    if (oracle.getToken() == null) {
                        this.$router.push("register");
                    } else {
                        this.$router.push("home");
                    }
                }, 1000);
            },
        },
        mounted() {
            oracle.axios("setting/getInfo", {"search_by": "com.mindandlove1.android"}, this.handshakeResult);
            // setTimeout(function () {
            //     document.getElementsByClassName('.lds-css').addClass('loading-hide');
            // }, 1000);
        },
    };
</script>
<style>
    .splash {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        /*background: red;*/
    }

    .lds-css {
        position: fixed;
        height: 100%;
        width: 100%;
        z-index: 99999;
        background-color: #fff;
        opacity: 1;
        visibility: visible;
        -webkit-transition: opacity 600ms, visibility 600ms;
        transition: opacity 600ms, visibility 600ms;
    }

    .lds-css.loading-hide {
        visibility: hidden;
        opacity: 0;
    }

    @keyframes lds-heart {
        0% {
            -webkit-transform: scale(0.85);
            transform: scale(0.85);
        }
        5% {
            -webkit-transform: scale(1);
            transform: scale(1);
        }
        39% {
            -webkit-transform: scale(0.75);
            transform: scale(0.75);
        }
        45% {
            -webkit-transform: scale(0.9);
            transform: scale(0.9);
        }
        60% {
            -webkit-transform: scale(0.85);
            transform: scale(0.85);
        }
        100% {
            -webkit-transform: scale(0.8);
            transform: scale(0.8);
        }
    }

    @-webkit-keyframes lds-heart {
        0% {
            -webkit-transform: scale(0.85);
            transform: scale(0.85);
        }
        5% {
            -webkit-transform: scale(1);
            transform: scale(1);
        }
        39% {
            -webkit-transform: scale(0.75);
            transform: scale(0.75);
        }
        45% {
            -webkit-transform: scale(0.9);
            transform: scale(0.9);
        }
        60% {
            -webkit-transform: scale(0.85);
            transform: scale(0.85);
        }
        100% {
            -webkit-transform: scale(0.8);
            transform: scale(0.8);
        }
    }

    .lds-heart {
        position: relative;
        -webkit-animation: lds-heart 1s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
        animation: lds-heart 1s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .lds-heart div {
        top: 72px;
        left: 60px;
        position: absolute;
        width: 80px;
        height: 80px;
        background: #ea3f34;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .lds-heart div:after,
    .lds-heart div:before {
        content: " ";
        position: absolute;
        display: block;
        width: 80px;
        height: 80px;
        background: #ea3f34;
    }

    .lds-heart div:before {
        left: -52px;
        border-radius: 50% 0 0 50%;
    }

    .lds-heart div:after {
        top: -52px;
        border-radius: 50% 50% 0 0;
    }

    .lds-heart {
        position: fixed;
        top: calc(50% - 100px);
        left: calc(50% - 100px);
        width: 200px !important;
        height: 200px !important;
        -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
        transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
    }

    .imageSplash {
        height: 100%;
        width: 100%;
        opacity: 0;
        animation: mymove 5s infinite;
    }

    .paddB {
        margin-bottom: 20px;
    }

    .splash img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    @keyframes mymove {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
</style>
